

export class LWFDto implements ILWFDto {
    id!: number | undefined;
    yearMonth!: string | undefined;
    fromAmount!: number;
    toAmount!: number;
    companyContribution!: number;
    employeeContribution!: number;
    monthDate!: Date;

    constructor(data?: ILWFDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.yearMonth = _data["yearMonth"];
            this.fromAmount = _data["fromAmount"];
            this.toAmount = _data["toAmount"];
            this.companyContribution = _data["companyContribution"];
            this.employeeContribution = _data["employeeContribution"];
            this.monthDate = _data["monthDate"] ? new Date(_data["monthDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LWFDto {
        data = typeof data === 'object' ? data : {};
        let result = new LWFDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["yearMonth"] = this.yearMonth;
        data["fromAmount"] = this.fromAmount;
        data["toAmount"] = this.toAmount;
        data["companyContribution"] = this.companyContribution;
        data["employeeContribution"] = this.employeeContribution;
        data["monthDate"] = this.monthDate ? this.monthDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ILWFDto {
    id: number | undefined;
    yearMonth: string | undefined;
    fromAmount: number;
    toAmount: number;
    companyContribution: number;
    employeeContribution: number;
    monthDate: Date;
}

